import { render } from "./DevSelect.vue?vue&type=template&id=17382539&scoped=true"
import script from "./DevSelect.vue?vue&type=script&lang=js"
export * from "./DevSelect.vue?vue&type=script&lang=js"

import "./DevSelect.vue?vue&type=style&index=0&id=17382539&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-17382539"

export default script